import * as Yup from "yup";

export const dmcaTakedownInitialValues = {
  legal_first_name: "",
  legal_last_name: "",
  profile_name: "",
  phone_number: "",
  email: "",
  url: "",
  proof_media: "",
  copyright_number: "",
  signature: "",
  wheel: null,
  segment: null,
  street_address: "",
  apartment_number: "",
  city: "",
  state: "",
  zip_code: "",
  country: "",
  description_of_work: "",
  infringement_url: "",
  explanation_of_infringement: "",
  statements: {
    goodFaith: false,
    declaration: false,
  },
  signature_consent: false,
};

export const validationSchema = Yup.object().shape({
  legal_first_name: Yup.string().required("First name is required"),
  legal_last_name: Yup.string().required("Last name is required"),
  profile_name: Yup.string().required("Profile name is required"),
  phone_number: Yup.string().required("Phone number is required"),
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
  url: Yup.string().url("Enter a valid URL").required("URL is required"),

  // Update proof_media to be an optional object that can also accept string values
  proof_media: Yup.mixed()
    .nullable()
    .transform((value) => {
      // Accept empty values
      if (!value) return null;
      return value;
    }),

  copyright_number: Yup.string(),
  signature: Yup.string().required("Signature is required"),
  wheel: Yup.number()
    .typeError("Wheel must be a number")
    .required("Wheel is required"),
  segment: Yup.number()
    .typeError("Segment must be a number")
    .required("Segment is required"),
  street_address: Yup.string().required("Street address is required"),
  apartment_number: Yup.string(),
  city: Yup.string().required("City is required"),
  state: Yup.string().required("State is required"),
  zip_code: Yup.string().required("ZIP code is required"),
  country: Yup.string().required("Country is required"),
  description_of_work: Yup.string().required("Description of work is required"),
  infringement_url: Yup.string().url("Enter a valid URL"),
  explanation_of_infringement: Yup.string(),

  // Add validation for checkboxes
  statements: Yup.object().shape({
    goodFaith: Yup.boolean()
      .oneOf([true], "You must agree to this statement")
      .required("You must agree to this statement"),
    declaration: Yup.boolean()
      .oneOf([true], "You must agree to this statement")
      .required("You must agree to this statement"),
  }),
  signature_consent: Yup.boolean()
    .oneOf([true], "You must agree to use your typed name as signature")
    .required("You must agree to use your typed name as signature"),
});
